import React from 'react';
import { VscStarFull } from 'react-icons/vsc';

export default function IputRating({ id, current, ...props }) {
    return (
        <div className="relative">
            <input
                {...props}
                id={'rating-' + id}
                type="radio"
                name="rating"
                value={id}
                className="absolute top-0 text-transparent bg-transparent border-0 appearance-none cursor-pointer peer size-5 checked:bg-none focus:bg-none focus:ring-0 focus:ring-offset-0"
            />
            <label
                htmlFor={'rating-' + id}
                className={`peer-checked:text-yellow-500 peer-hover:text-yellow-500 ${
                    current >= id ? 'text-yellow-500' : 'text-gray-300'
                }  pointer-events-none dark:peer-checked:text-yellow-600 dark:text-gray-600`}
            >
                <VscStarFull className="flex-shrink-0 size-6" />
            </label>
        </div>
    );
}
